<template>
  <div>
  <div class="content">
    <div class="service_content">
        <!-- <p class="title">
          我们一起来学习价值投资
        </p>
        <p style="margin-top:15px" class="text_content">
          价值投资和炒股票，虽然买的都是股票，但是实际上有完全不同的交易理念。
        </p>
        <p class="text_content">
          炒股票是一种投机行为，通过判断股票价格的上涨趋势，在上涨趋势开始阶段买入，在股票价格未来高位时卖出，赚取买卖价差。炒股票风险是很高的，一旦判断错误高点接盘，不管是套牢还是割肉出局，都是投资者不想看到但是有无法避免的结局。
        </p>
        <p class="text_content">
          价值投资是一种投资行为，通过分析上市公司的质地来判断股票的价值，这只股票到底值多少钱，价格低于股票价值时买入，一旦买入就拥有了和股票数量对应的企业所有权，作为股东长期持有，分享企业成长带来的收益。价值投资可能不会短时间内暴利，但是风险是很低的，因为是低位买入，股票价格是围绕价值波动的，长期看风险极低的。
        </p>
        <p class="text_content">
          价值投资和炒股票相比，最大的区别是思维视角不一样。价值投资考虑的不是能不能赚钱，而是坚持低位买入来保证不亏钱。
        </p>
        <p class="text_content">
          wh10以上述原则为基础，对A股上市企业进行了深度的挖掘和整理，提供专业化价值判断工具：EVA分析、利润滤镜、风险甄别等功能一一提供盈利质量和财务风险分析，规避投资风险；主营构成、行业地位、财务透视等功能一一提供经营状况、资产和盈利透视分析，快速形成和扩大能力圈；价值分析、机构预测等功能一一提供基本面定价模型，确定估值水平和安全边际。
        </p>
        <p class="title">
          我们一起来学习股票量化投资
        </p>
        <p style="margin-top:15px" class="text_content">
          股票量化和期货量化虽然字面上都是量化，但实际上有着完全不同的交易理念。
        </p>
        <p class="text_content">
          期货量化模型，研究对象是某一具体的合约，管理的是买卖交易行为，通过挖掘数据找趋势规律确定买入卖出时机，来赚取买卖价差，属于择时交易的范畴。这个和期货合约的特点有关，大多的期货合约有效期一年，到期后无法继续持有，期货市场里中短期交易者居多。
        </p>
        <p class="text_content">
          股票量化模型，研究对象是全市场的3000多只股票，管理的是持仓股票池，综合利用财务数据、市场表现、基本面、技术面等各类因子，通过统计分析找出一些符合持有条件的股票，纳入到持仓股票池，长期持有，通过跟随股票增值来实现账户的净值增长，属于选股交易的范畴。持仓股票池是动态的，定期加入新股票和剔除旧股票。剔除一只股票不是因为这只股票大幅上涨而止盈，也不是因为这只股票大幅下跌而止损，而是因为这只股票不再符合持有条件。
        </p>
        <p class="text_content">
          从模型编写构成角度看，股票模型和期货模型最大的区别是股票模型只有一种条件：持有股票的条件，而期货模型有二种条件：买入的条件和卖出的条件。
        </p>
        <p class="text_content">
          wh10软件以价值投资理念为基础，提供专业的股票量化研究服务。提供300多个优选因子，可以检验因子有效性、分析因子相关性、合成综合因子作为选股条件，生成持仓股票池、策略分析报告和调仓列表。
        </p>
        <table border="0" cellpadding="0" cellspacing="0" class="list" name="table" id="table">
				<tbody>
					<tr class="header" align="center">
						<td height="40" align="center" bgcolor="#c86363" class="lLightBorder bBlackBorder rBlackBorder tLightBorder">分类</td>
						<td height="40" align="center" bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">本质</td>
						<td height="40" align="center" bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">判断依据</td>
						<td height="40" align="center" bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">计算结果</td>
						<td height="40" align="center" bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">是否择时</td>
					</tr>
					<tr>
						<td height="40" align="center" valign="middle" class="bLightBorder rLightBorder lLightBorder">
							期货量化
						</td>
						<td class="tableClass bLightBorder rLightBorder " align="center">管理买卖行为</td>
						<td class="tableClass bLightBorder rLightBorder" align="center">开平仓条件</td>
						<td class="tableClass bLightBorder rLightBorder" align="center">买卖信号</td>
						<td align="center" class=" bLightBorder rBlackBorder">是</td>
					</tr>
					<tr>
						<td height="40" align="center" valign="middle" class="bLightBorder rLightBorder lLightBorder">
							股票量化
						</td>
						<td class="tableClass bLightBorder rLightBorder " align="center">管理持仓股票池</td>
						<td class="tableClass bLightBorder rLightBorder" align="center">多因子综合排名</td>
						<td class="tableClass bLightBorder rLightBorder" align="center">调仓列表</td>
						<td align="center" class=" bLightBorder rBlackBorder">否</td>
					</tr>

				</tbody>
			</table> -->
      <p class="title">
          参考资料
        </p>
        <div class="goodwz">
          <!-- <div class="goodlj" style="color:#2b64b3"><span class="goodjing" style="margin-right:0"></span> <router-link to="/garden?id=0" target="_blank" class="wh10-video-tit">用wh10来做股票-价值投资</router-link> 
          <span @click="clicktjnew(sp1)" style="display:inline-block;width:230px"><img src="../../assets/img/bof.png" alt="" style="margin:0 4px 0 0px;position:relative;bottom:-3px"><span class="spppt">在线看视频</span><span style="color:#9c9c9c">（观看{{num1}}次）</span></span>
          
         
          </div> -->

<!-- 
          <div class="goodlj" style="color:#2b64b3"><span class="goodjing" style="margin-right:0"></span> <router-link to="/garden?id=27" target="_blank" class="wh10-video-tit">如何用wh5软件做股票财务分析</router-link> 

          <span @click="clicktjnew(sp4)" style="display:inline-block;width:230px"><img src="../../assets/img/bof.png" alt="" style="margin:0 4px 0 0px;position:relative;bottom:-3px"><span class="spppt">在线看视频</span><span style="color:#9c9c9c">（观看{{num8}}次）</span></span>
          
          </div>
          <div class="goodlj" style="color:#2b64b3"><span class="goodjing" style="margin-right:0"></span> <router-link to="/garden?id=30" target="_blank" class="wh10-video-tit">如何用wh5投资一篮子股票</router-link> 

          <span @click="clicktjnew(sp3)" style="display:inline-block;width:230px"><img src="../../assets/img/bof.png" alt="" style="margin:0 4px 0 0px;position:relative;bottom:-3px"><span class="spppt">在线看视频</span><span style="color:#9c9c9c">（观看{{num6}}次）</span></span>
          
          </div> -->


          <!-- <div class="goodlj"><span class="goodjing"></span><router-link to='/garden?id=22' target='_blank'>价值投资概念的白话解读</router-link></div> -->
          <div class="goodlj ss" >-=价值投资=-</div>
          <div class="goodlj"><router-link to='/garden?id=1' target='_blank'>如何在中国做价值投资？</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=2' target='_blank'>巴菲特价值投资理念：领悟后竟然是人生真谛！</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=3' target='_blank'>做好价值投资的三大要点</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=4' target='_blank'>什么才是真正的价值投资</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=5' target='_blank'>巴菲特最著名的演讲:价值投资为什么能够持续战胜市场？</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=6' target='_blank'>段永平：价值投资是关注长期的思维方式</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=7' target='_blank'>李录：价值投资的知行合一</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=8' target='_blank'>『指数』价值投资的四大原则</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=9' target='_blank'>李录北大演讲：价值投资在中国行得通</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=10' target='_blank'>价值投资首先要考虑价值，而不是价格</router-link></div>
          <div class="goodlj"><router-link to='/garden?id=11' target='_blank'>芒格最新观点 ：价值投资“永不过时”</router-link></div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import vcd from "./frame/vcd.vue"
export default {
  data(){
    return{
      num1:1,
      num2:1,
      num4:1,
      num5:1,
      num6:1,
      num7:1,
      num8:1,
      num9:1,
      num10:1,
      num11:1,
      sp1:'https://outin-7436d088141511ebb1d500163e1c7426.oss-cn-shanghai.aliyuncs.com/sv/3ade592-1830cc41ebb/3ade592-1830cc41ebb.mp4',
      sp2:'https://outin-7436d088141511ebb1d500163e1c7426.oss-cn-shanghai.aliyuncs.com/sv/2668ebea-1840ced8a61/2668ebea-1840ced8a61.mp4',
      sp3:'https://outin-7436d088141511ebb1d500163e1c7426.oss-cn-shanghai.aliyuncs.com/sv/343b1638-18513499644/343b1638-18513499644.mp4',
      sp4:'https://outin-7436d088141511ebb1d500163e1c7426.oss-cn-shanghai.aliyuncs.com/sv/53efdb84-18479f5c322/53efdb84-18479f5c322.mp4',
      sp5:'https://outin-7436d088141511ebb1d500163e1c7426.oss-cn-shanghai.aliyuncs.com/sv/4eb667ba-1840d238be1/4eb667ba-1840d238be1.mp4',
    }
  },
methods:{
  clicktjnew(sp){
    var type
    if(sp==this.sp1){
      type=1
    }
    else if(sp==this.sp2){
      type=4
    }
    else if(sp==this.sp3){
      type=6
    }
    else if(sp==this.sp4){
      type=8
    }
    else if(sp==this.sp5){
      type=10
    }
    axios.get("https://webapi.wenhua.com.cn/update/api/Update/SetCount",{
      params:{
        type:type,
      }
    }).then((res) => {
        if(res.data.Status==true){
          this.getcount()
        }
    });
    this.$root.$frame.box(vcd,{
    unvariable:false,
    width:'1000px',
    height:'600px',
    props:{
        src:sp
    }
})

},
clicktjnew1(){
  axios.get("https://webapi.wenhua.com.cn/update/api/Update/SetCount",{
      params:{
        type:2,
      }
    }).then((res) => {
        if(res.data.Status==true){
          this.getcount()
        }
    });
},
clicktjnew2(){
  axios.get("https://webapi.wenhua.com.cn/update/api/Update/SetCount",{
      params:{
        type:5,
      }
    }).then((res) => {
        if(res.data.Status==true){
          this.getcount()
        }
    });
},
getcount(){
  axios.get("https://webapi.wenhua.com.cn/update/api/Update/Getcount").then((res) => {
      if(res.data.Status==true){
        res.data.ResultData.forEach(el => {
          if(el.type==1){
            this.num1=el.num
          }
          if(el.type==2){
            this.num2=el.num
          }
           if(el.type==4){
            this.num4=el.num
          }
          if(el.type==5){
            this.num5=el.num
          }
          if(el.type==6){
            this.num6=el.num
          }
          if(el.type==7){
            this.num7=el.num
          }
          if(el.type==8){
            this.num8=el.num
          }
          if(el.type==9){
            this.num9=el.num
          }
          if(el.type==10){
            this.num10=el.num
          }
          if(el.type==11){
            this.num11=el.num
          }
        });
      }
    });
}
},
mounted(){
  this.getcount()

}
}
</script>

<style scoped>
  .content{
    background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=16) no-repeat top;
    width: 100%;
    min-height: 600px;
    padding-top: 236px;
  }
  .service_content{
    width: 990px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 0 20px -5px #ccc; 
    min-height: 600px;
    padding-bottom: 50px;
    font-size: 14px;
  }
  .service_content .title{
    color: #5f5f5f;
    border-bottom: 1px dashed #a8a8a8;
    line-height: 40px;
    font-size: 22px;
  }
  .text_content{
    text-indent: 2em;
    font-size: 14px;
    line-height: 20px;
    color:#6f6f6f;
    padding: 10px 0;
    text-align: justify;
  }
  .title2{
    font-size: 16px;
    color: #5d0f0b;
    border-left: 4px solid #e24a49;
    font-weight: bold;
    padding-left: 10px;
    margin: 15px 0;
  }
  #table {
			width: 590px;
			margin: 20px auto;
            color: #6f6f6f;
            font-size: 15px;
		}
#table td{
line-height: 40px;
}
		/*第一种颜色*/
		#table tr.color1 {
			background-color: #FFFFFF;
		}

		/*第二种颜色*/
		#table tr.color2 {
			background-color: #F8F8F8;
		}

		#table td.teacher {
			background-color: #fff;
		}

		#table td.date {
			background-color: #F0F0F0;
		}

		#table td.time {
			background-color: #f8f8f8;
		}
		#table .header{
			color: #fff;
		}
		#table td.time p {
			margin: 0;
			padding: 0;
		}

		#table td span {
			/*margin-left:5px;*/
		}
		/* #table td {
			border-color: 1px solid #bfbfbf;
		} */
        .bBlackBorder {
			border-bottom: 1px solid #bfbfbf;
		}

		.rBlackBorder {
			border-right: 1px solid #bfbfbf;
		}

		.bGreyBorder {
			border-bottom: 1px solid #BFBFBF;
		}

		.rLightBorder {
			border-right: 1px solid #bfbfbf;
		}

		.bLightBorder {
			border-bottom: 1px solid #bfbfbf;
		}
		.tLightBorder{
			border-top: 1px solid #bfbfbf;
		}
		.lLightBorder{
			border-left: 1px solid #bfbfbf;
		}
    .goodwz{
      width: 890px;
      margin:0 auto ;
      margin-top: 30px;
    }
    .goodlj{
      width: 100%;
      border-bottom: 1px solid #e3e6eb;
      height: 40px;
      line-height: 40px;
    }
    .goodjing{
      width: 19px;
      height: 17px;
      /* border-radius: 3px 3px  0 3px;
      background: #fe6567;
      border: 1px solid #e75d5d; */
      display: inline-block;
      line-height: 17px;
      text-align: center;
      color: white;
      font-size: 12px;
      margin: 0 5px;
      background: url(../../assets/img/goodd.png)no-repeat center;
    }
    .goodlj a{
     color: #2b64b3;
     text-decoration: none;
    }
    .goodlj a:visited{
      color: #2b64b3;
    }
    .ss{
      color: #ff6668;
      background: #fff3f3;
      border-bottom:1px solid #f8e5e9 ;
      height: 32px;
      line-height: 32px;
      padding-left: 7px;
    }
    .spppt{
      text-decoration: underline;
      cursor: pointer;
    }
    .wh10-video-tit{
      display: inline-block;
      width: 220px;
    }
</style>